import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';

import encryptionHtmlAndScriptIE from '../../../common/components/auth/dbsecurelogin/webviewencryptionscriptIE';
import Login from './login';

import LogoutConfirmModal from '../../../screens/auth/logout/logout-confirm-modal';

import { LoadingCircle as BusyIcon } from '../../../components/common/loading';


class LoginContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.cryptoPass = undefined;
    this.props.getconfig();
    this.props.loginTerms.onGetPdf();
  }

  state = {
    isModalActive: false,
    userId: undefined,
    password: undefined,
    userIdEmpty: undefined,
    passwordEmpty: undefined,
    showUserPopover: false,
    showPasswordPopover: false,
  };

  componentWillMount() {
    this.props.setAuthorised(false);
  }

  componentDidMount() {
    this.addEventHandlerForPopover();
    this.props.platform.detectBrowser();
  }

  componentWillUnmount() {
    this.removeEventHandlerForPopover();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.auth.cryptoEncryptedObjSuccess) {
      this.props.auth.setCryptoEncryptedObjSuccess(false);
      this.doLoginIE(newProps);
    }
  }

  doLoginIE(newProps) {
    console.log('this.genrateCryptoPass = ' + newProps);
    const { password } = this.state;
    const globalAuth = newProps.auth;
    const { token, modulus, exponent } = globalAuth.cryptoEncryptedObj;
    const cryptoEncryptionRequestParam = {
      password,
      modulus,
      exponent,
      token,
      originType: 'login',
    };

    const self = this;

    encryptionHtmlAndScriptIE(
      JSON.stringify(cryptoEncryptionRequestParam),
      (encryptedData) => {
        console.log(
          'encryptedData after encryption in doLoginIE is ' + encryptedData
        );

        const data = encryptedData;
        if (data === 'ERROR') {
          globalAuth.setInvalidLogin(true);
          globalAuth.setErrorMsg('Unable to connect. Please try again later.');
          globalAuth.setLoginBusy(false);
        } else {
          const { userId, password } = self.state;
          const globalAuth = self.props.auth;
          const {
            token,
            modulus,
            exponent,
            randnr,
            pubkey,
            seskey,
          } = globalAuth.cryptoEncryptedObj;

          globalAuth.onGlobalAuthLogin({
            userId,
            password,
            data,
            token,
            randnr,
            pubkey,
            seskey,
          });
        }
      }
    );
  };

  handleShowUserPopover = () => {
    if (this.state.showPasswordPopover) {
      this.setState((currentState) => ({
        showPasswordPopover: !currentState.showPasswordPopover,
        showUserPopover: !currentState.showUserPopover
      }));
    }
    else {
      this.setState((currentState) => ({ showUserPopover: !currentState.showUserPopover }));
    }
  };

  handleShowPasswordPopover = () => {
    if (this.state.showUserPopover) {
      this.setState((currentState) => ({
        showPasswordPopover: !currentState.showPasswordPopover,
        showUserPopover: !currentState.showUserPopover
      }));
    }
    else {
      this.setState((currentState) => ({ showPasswordPopover: !currentState.showPasswordPopover }));
    }
  }

  handleTextFieldEnterPress = () => {
    this.setState({
      showUserPopover: false,
      showPasswordPopover: false
    });
  }

  addEventHandlerForPopover = () => {
    document.addEventListener('click', this.closePopovers);
  }

  removeEventHandlerForPopover = () => {
    document.removeEventListener('click', this.closePopovers);
  }

  closePopovers = (ev) => {
    const childPopover = ev.target && ev.target.querySelectorAll('div.popover');
    if (childPopover.length > 0) {
      this.setState({
        showUserPopover: false,
        showPasswordPopover: false
      });
    };
  }

  handleEnterPress = (ev) => {
    if (ev.key === "Enter") {
      const userId = document.getElementById("loginUserNameSelection").value;
      const password = document.getElementById("loginPasswordSelection").value;
      this.handleLogin(userId, password);
    }
  }

  handleLogin = (userId, password) => {
    const { type = 'login' } = this.state;
    this.setState({
      userId,
      password
    });
    this.props.auth.globalAuthEncryptionKey({ userId, type });
  };

  handleSetupNewPassword = () => {
    const { resetcode: { resetVariables } } = this.props;
    this.setState(() => ({
      showForgotPasswordPage: true,
    }));
    resetVariables();
    this.toggleModal('forgot-password');
  };

  render() {

    const { auth: { loginBusy } } = this.props;
    return (
      <View className="Login-container">
        <View className="Login-logo-circle" />
        {!this.props.auth.authorised &&
          <Login
            {...this.props}
            isLoginBusy={loginBusy}
            onInputChanged={this.handleInputChanged}
            onLogin={this.handleLogin}
            handleShowPasswordPopover={this.handleShowPasswordPopover}
            handleShowUserPopover={this.handleShowUserPopover}
            showUserPopover={this.state.showUserPopover}
            showPasswordPopover={this.state.showPasswordPopover}
            handleSetupNewPassword={this.handleSetupNewPassword}
            handleEnterPress={this.handleEnterPress}
            handleTextFieldEnterPress={this.handleTextFieldEnterPress}
            saveLanguage={this.props.languages.saveLanguage}
            destLanguage={this.props.languages.destLanguage}
            destLanguageCode={this.props.languages.destLanguageCode}
            region={this.props.config.regionCode}
          >
            {this.props.children}
          </Login>
        }
        {this.props.auth.authorised &&
          <BusyIcon />
        }
        <LogoutConfirmModal />
      </View>
    );
  }
}

LoginContainer.propTypes = {
  auth: PropTypes.shape({
    onValidateDevice: PropTypes.func,
    plannedServerDowntimeCheck: PropTypes.func,
    onGlobalAuthLogin: PropTypes.func,
  }),
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    config: { regionCode: true },
    app: {
      config: {
        showchangepassword: true,
      }
    },
    getconfig: { $call: 'app.getConfig' },
    auth: {
      authorised: true,
      loginBusy: true,
      errorMsg: true,
      cryptoEncryptedObj: true,
      globalAuthEncryptionKey: { $call: 'getGlobalAuthEncryptionKey' },
      onGlobalAuthLogin: { $call: 'globalauthlogin' },
      cryptoEncryptedObjSuccess: true,
      setCryptoEncryptedObjSuccess: { $set: 'cryptoEncryptedObjSuccess' },
      setInvalidLogin: { $set: 'invalidLogin' },
      setLoginBusy: { $set: 'loginBusy' },
      setErrorMsg: { $set: 'errorMsg' },
    },
    languages: {
      saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
      destLanguage: true,
      destLanguageCode: true,
    },
    setAuthorised: { $call: 'auth.setAuthorised' },
    changePage: { $call: 'ui.history.push' },
    platform: {
      detectBrowser: { $call: 'initBrowser' },
    },
    loginTerms: {
      onGetPdf: { $call: 'getPdfLink' },
      pdfLinkData: true,
    },
    i18n: {
      messages: true,
    },
    resetcode: {
      resetVariables: { $call: 'resetVariables' },
    }
  },
})(LoginContainer);
